import React from 'react';
import { useNavigate } from 'react-router-dom';
const WireframeCheckoutPage = () => {
  const navigate = useNavigate();
  return <div className="w-full bg-white p-3 font-mono text-[11px]" data-id="element-250">
      {/* Wireframe Header */}
      <header className="border border-dashed border-gray-400 p-2 mb-4" data-id="element-251">
        <div className="flex justify-between items-center" data-id="element-252">
          <div className="bg-gray-300 h-6 w-20 flex items-center justify-center text-[10px] text-gray-600" data-id="element-253">
            LOGO
          </div>
          <div className="flex gap-2" data-id="element-254">
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-255">
              Nav
            </div>
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-256">
              Nav
            </div>
            <div className="bg-gray-200 h-5 w-12 flex items-center justify-center text-[10px] text-gray-500" data-id="element-257">
              Nav
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-4xl mx-auto" data-id="element-258">
        <div className="bg-gray-200 h-4 w-20 mb-2 flex items-center px-1 text-[9px] text-gray-500" data-id="element-259">
          ← Back
        </div>
        <div className="bg-gray-300 h-7 w-28 mb-4 flex items-center px-2 text-[11px] text-gray-600" data-id="element-260">
          H1: Checkout
        </div>

        <div className="flex flex-col md:flex-row gap-4" data-id="element-261">
          {/* Form Section */}
          <div className="md:w-2/3 space-y-3" data-id="element-262">
            {/* Tabs */}
            <div className="border border-dashed border-gray-400 p-2" data-id="element-263">
              <div className="flex border-b border-gray-300" data-id="element-264">
                <div className="border-b-2 border-gray-600 px-3 py-1 text-[10px] text-gray-700" data-id="element-265">
                  Guest
                </div>
                <div className="px-3 py-1 text-[10px] text-gray-500" data-id="element-266">
                  Account
                </div>
              </div>
            </div>

            {/* Contact Info */}
            <div className="border border-dashed border-gray-400 p-3" data-id="element-267">
              <div className="bg-gray-300 h-5 w-28 mb-3 flex items-center px-2 text-[10px] text-gray-600" data-id="element-268">
                Contact Info
              </div>
              <div className="grid grid-cols-2 gap-2" data-id="element-269">
                <div className="space-y-0.5" data-id="element-270">
                  <div className="bg-gray-200 h-3 w-16 flex items-center px-1 text-[8px] text-gray-500" data-id="element-271">
                    Label
                  </div>
                  <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-272">
                    [First Name]
                  </div>
                </div>
                <div className="space-y-0.5" data-id="element-273">
                  <div className="bg-gray-200 h-3 w-16 flex items-center px-1 text-[8px] text-gray-500" data-id="element-274">
                    Label
                  </div>
                  <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-275">
                    [Last Name]
                  </div>
                </div>
                <div className="col-span-2 space-y-0.5" data-id="element-276">
                  <div className="bg-gray-200 h-3 w-12 flex items-center px-1 text-[8px] text-gray-500" data-id="element-277">
                    Label
                  </div>
                  <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-278">
                    [Email]
                  </div>
                </div>
                <div className="col-span-2 space-y-0.5" data-id="element-279">
                  <div className="bg-gray-200 h-3 w-12 flex items-center px-1 text-[8px] text-gray-500" data-id="element-280">
                    Label
                  </div>
                  <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-281">
                    [Phone]
                  </div>
                </div>
              </div>
            </div>

            {/* Address */}
            <div className="border border-dashed border-gray-400 p-3" data-id="element-282">
              <div className="bg-gray-300 h-5 w-20 mb-3 flex items-center px-2 text-[10px] text-gray-600" data-id="element-283">
                Address
              </div>
              <div className="space-y-2" data-id="element-284">
                <div className="space-y-0.5" data-id="element-285">
                  <div className="bg-gray-200 h-3 w-14 flex items-center px-1 text-[8px] text-gray-500" data-id="element-286">
                    Label
                  </div>
                  <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-287">
                    [Address]
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2" data-id="element-288">
                  <div className="space-y-0.5" data-id="element-289">
                    <div className="bg-gray-200 h-3 w-10 flex items-center px-1 text-[8px] text-gray-500" data-id="element-290">
                      Label
                    </div>
                    <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-291">
                      [City]
                    </div>
                  </div>
                  <div className="space-y-0.5" data-id="element-292">
                    <div className="bg-gray-200 h-3 w-14 flex items-center px-1 text-[8px] text-gray-500" data-id="element-293">
                      Label
                    </div>
                    <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-294">
                      [Postcode]
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Payment */}
            <div className="border border-dashed border-gray-400 p-3" data-id="element-295">
              <div className="bg-gray-300 h-5 w-20 mb-3 flex items-center px-2 text-[10px] text-gray-600" data-id="element-296">
                Payment
              </div>
              <div className="space-y-2" data-id="element-297">
                <div className="space-y-0.5" data-id="element-298">
                  <div className="bg-gray-200 h-3 w-20 flex items-center px-1 text-[8px] text-gray-500" data-id="element-299">
                    Card Number
                  </div>
                  <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-300">
                    [•••• •••• •••• ••••]
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2" data-id="element-301">
                  <div className="space-y-0.5" data-id="element-302">
                    <div className="bg-gray-200 h-3 w-12 flex items-center px-1 text-[8px] text-gray-500" data-id="element-303">
                      Expiry
                    </div>
                    <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-304">
                      [MM/YY]
                    </div>
                  </div>
                  <div className="space-y-0.5" data-id="element-305">
                    <div className="bg-gray-200 h-3 w-10 flex items-center px-1 text-[8px] text-gray-500" data-id="element-306">
                      CVV
                    </div>
                    <div className="border border-gray-400 h-7 flex items-center px-1 text-[9px] text-gray-500" data-id="element-307">
                      [•••]
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Order Summary */}
          <div className="md:w-1/3" data-id="element-308">
            <div className="border border-dashed border-gray-400 bg-gray-100 p-3" data-id="element-309">
              <div className="bg-gray-300 h-5 w-24 mb-3 flex items-center px-2 text-[10px] text-gray-600" data-id="element-310">
                Order Summary
              </div>

              <div className="border-b border-gray-300 pb-2 mb-2" data-id="element-311">
                <div className="bg-gray-300 h-4 w-24 mb-0.5 flex items-center px-1 text-[9px] text-gray-600" data-id="element-312">
                  Service Name
                </div>
                <div className="bg-gray-200 h-3 w-32 mb-1 flex items-center px-1 text-[8px] text-gray-500" data-id="element-313">
                  Duration with Therapist
                </div>
                <div className="flex justify-between" data-id="element-314">
                  <div className="bg-gray-200 h-3 w-14 flex items-center px-1 text-[8px] text-gray-500" data-id="element-315">
                    Date/Time
                  </div>
                  <div className="bg-gray-300 h-3 w-20 flex items-center px-1 text-[8px] text-gray-600" data-id="element-316">
                    Jun 15, 2PM
                  </div>
                </div>
              </div>

              <div className="space-y-1 border-b border-gray-300 pb-2 mb-2" data-id="element-317">
                <div className="flex justify-between" data-id="element-318">
                  <div className="bg-gray-200 h-3 w-14 flex items-center px-1 text-[8px] text-gray-500" data-id="element-319">
                    Subtotal
                  </div>
                  <div className="bg-gray-300 h-3 w-10 flex items-center px-1 text-[8px] text-gray-600" data-id="element-320">
                    £XX
                  </div>
                </div>
                <div className="flex justify-between" data-id="element-321">
                  <div className="bg-gray-200 h-3 w-16 flex items-center px-1 text-[8px] text-gray-500" data-id="element-322">
                    Travel Fee
                  </div>
                  <div className="bg-gray-300 h-3 w-10 flex items-center px-1 text-[8px] text-gray-600" data-id="element-323">
                    £XX
                  </div>
                </div>
              </div>

              <div className="flex justify-between mb-3" data-id="element-324">
                <div className="bg-gray-300 h-4 w-10 flex items-center px-1 text-[9px] text-gray-600" data-id="element-325">
                  Total
                </div>
                <div className="bg-gray-400 h-4 w-12 flex items-center px-1 text-[9px] text-white" data-id="element-326">
                  £XX
                </div>
              </div>

              <div className="bg-gray-400 h-8 w-full flex items-center justify-center text-[10px] text-white" data-id="element-327">
                Complete Booking
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Annotation */}
      <div className="text-[9px] text-gray-400 text-center mt-4 mb-3" data-id="element-328">
        Wireframe v1.0 — Checkout
      </div>

      {/* Navigation */}
      <div className="flex justify-center gap-2" data-id="element-329">
        <button onClick={() => navigate('/wireframe/booking')} className="border border-gray-400 px-3 py-1.5 text-[10px] text-gray-600 hover:bg-gray-100" data-id="element-330">
          ← Booking
        </button>
        <button onClick={() => navigate('/')} className="border border-gray-400 px-3 py-1.5 text-[10px] text-gray-600 hover:bg-gray-100" data-id="element-331">
          Final Prototype →
        </button>
      </div>
    </div>;
};
export default WireframeCheckoutPage;